/**
 * Shared react-select option chrome — follows Style Settings tokens on <html>.
 *
 * selected (+ hover on selected): buy-color tint + buy text (like left symbol selected-row)
 * hover / focus (not selected): gray row-hover + content text (like left symbol hover)
 */

/** Prefix for modal form selects — pair with .modal-select__* CSS in appearance.scss */
export const MODAL_SELECT_PREFIX = 'modal-select';

/**
 * Modal/form react-select chrome — same look as .amountInput + Direction filters:
 * surface-panel fill, surface-border, content text, no separator.
 */
export function modalSelectStyles(width = '150px', extras = {}) {
  const buy = 'var(--buy-color)';
  const border = 'var(--surface-border)';
  const controlBg = 'var(--surface-panel)';
  const menuBg = 'var(--surface-panel)';
  const text = 'var(--content-primary)';
  const muted = 'var(--content-secondary)';

  return {
    control: (provided, state) => ({
      ...provided,
      minHeight: '27px',
      height: '27px',
      width,
      borderRadius: '0.375rem',
      borderColor: state.isFocused ? buy : border,
      backgroundColor: controlBg,
      color: text,
      boxShadow: 'none',
      cursor: state.isDisabled ? 'not-allowed' : 'pointer',
      opacity: state.isDisabled ? 0.65 : 1,
      alignItems: 'center',
      boxSizing: 'border-box',
      '&:hover': {
        borderColor: buy,
        boxShadow: 'none',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 8px',
      height: '25px',
      display: 'flex',
      alignItems: 'center',
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      color: text,
      fontSize: '12px',
      lineHeight: '1.2',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: muted,
      fontSize: '12px',
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      color: text,
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '25px',
      alignSelf: 'center',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: '0 6px',
      color: state.isFocused || state.selectProps.menuIsOpen ? buy : muted,
      transition: 'color 0.15s ease',
      '&:hover': {
        color: buy,
      },
      svg: {
        width: '14px',
        height: '14px',
        transition: 'transform 0.2s ease',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        transformOrigin: 'center',
      },
    }),
    option: (provided, state) => dropdownOptionStyle(provided, state, {
      padding: '0.3rem 0.75rem',
      fontSize: '12px',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: menuBg,
      margin: '4px 0 0 0',
      zIndex: 111,
      overflow: 'hidden',
      borderRadius: '6px',
      border: `1px solid ${border}`,
      boxShadow: '0 4px 14px rgba(32, 44, 60, 0.09)',
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 100000,
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '140px',
      minHeight: '3px',
      width: '100%',
      overflowY: 'auto',
      padding: '2px 0',
    }),
    ...extras,
  };
}

export function dropdownOptionStyle(provided, state, extras = {}) {
  const selectedLook = {
    backgroundColor: 'var(--dropdown-selected-bg) !important',
    color: 'var(--dropdown-selected-fg, var(--buy-color)) !important',
  };
  const hoverLook = {
    backgroundColor: 'var(--dropdown-hover-bg, var(--row-hover)) !important',
    color: 'var(--dropdown-hover-fg, var(--content-primary)) !important',
  };
  const idleLook = {
    backgroundColor: 'transparent',
    color: 'var(--content-secondary, #b8bcc8) !important',
  };
  const look = state.isSelected ? selectedLook : state.isFocused ? hoverLook : idleLook;

  return {
    ...provided,
    cursor: 'pointer',
    borderBottom: 'none',
    ...extras,
    ...look,
    '&:hover': state.isSelected ? selectedLook : hoverLook,
    '&:active': state.isSelected ? selectedLook : hoverLook,
    '&:nth-last-child(1)': {
      borderBottom: 'none !important',
      ...(extras['&:nth-last-child(1)'] || {}),
    },
  };
}
